import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, ViewChild  } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule, Table } from 'primeng/table';
import { RouterLink, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AuthService } from '../../../../services/auth.service';
import { PageTitleService } from '../../../../services/pagetitle.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { Base64UrlService } from '../../../../services/base64-url.service';
import { AdminService } from '../../../../services/admin.service';
import { HttpClient } from '@angular/common/http';

/*----Prime NG----*/
import { InputTextModule } from 'primeng/inputtext';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { FormsModule } from "@angular/forms";

@Component({
  selector: 'app-rep-home',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonModule, TableModule, InputTextModule, InputIconModule, IconFieldModule, FormsModule],
  providers: [Base64UrlService],
  templateUrl: './rep-home.component.html',
  styleUrl: './rep-home.component.scss'
})
export class RepHomeComponent {
  @ViewChild('dt1', { static: false }) dt1: any;
  @ViewChild('dt2', { static: false }) dt2: any;
  userName: any;
  lang: any;
  associatesList: any[] = [];
  filteredAssociatesList: any[] = [];
  private associatesSearchText: string = '';
  companiesList: any[] = [];
  filteredCompaniesList: any[] = [];
  private searchText: string = '';
  // 1つ目テーブルへのBack用に状態を保存
  private savedSearchText: string = '';
  private savedDt1First: number = 0;
  // タイムシート画面から戻った際の表２復元用
  private pendingReturnState: any = null;
  monthDropdown: any;
  userCode: any;
  // These hold filtered data
  visibleDataCom: any[] = [];
  visibleData: any[] = [];
  totalCount: number = 0;
  dropDowndate: any;
  // Server-side pagination for Company View (false=全件取得後クライアント側ソート・ページング)
  currentPage: number = 1;
  pageSize: number = 20;
  totalPages: number = 0;
  totalRecords: number = 0;
  enableServerPaginationCompanies: boolean = false;
  // Server-side pagination for Associate View
  currentPageAssociates: number = 1;
  pageSizeAssociates: number = 20;
  totalPagesAssociates: number = 0;
  totalRecordsAssociates: number = 0;
  enableServerPaginationAssociates: boolean = false;
  branchDropdown: any[] = [];
  customerDropdown: any[] = [];
  selectedBranch: string = '-1';
  selectedCustomer: string = '-1';
  selectedService: string = '-1';
  selectedSection: string = '-1';
  selectedDate: string = '';
  weekEndingDate: string = '';
  displayByCompany: boolean = false;
  timeSheetDate: string = '';
  selectedCompanyName: string = '';
  selectedSectionName: string = '';
  isLoading: boolean = false;

  constructor(private auth: AuthService, private translate: TranslateService, private ts: TimesheetService, private as: AdminService, private en: EncryptionService, private pageTitle: PageTitleService, private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {

      this.lang = (localStorage.getItem('site_lang') ? localStorage.getItem('site_lang') : 'en');
      // console.log(this.lang)
      translate.use(this.lang);
    }
  }
  

  ngOnInit() {
    console.log('🚀 rep-home component initialized');
    console.time('⏱️ Total component load');
    this.userName = this.auth.getName();
    this.userCode = this.auth.getCode();
    this.pageTitle.setTitle('menu.proxy');
    if (isPlatformBrowser(this.platformId)) {
      const currentYear = new Date().getFullYear();
      const currentMonth = String(new Date().getMonth() + 1).padStart(2, '0');
      this.selectedDate = `01-${currentMonth}-${currentYear}`;
      console.log(this.selectedDate)
      this.timeSheetDate = Base64UrlService.encode(this.en.encryptionAES(`${currentYear}-${currentMonth}-01`));
      // タイムシート画面からの戻り状態を復元
      const savedState = sessionStorage.getItem('rep_home_return_state');
      if (savedState) {
        this.pendingReturnState = JSON.parse(savedState);
        sessionStorage.removeItem('rep_home_return_state');
      }
      this.getAssociates();
    }
  }

  getAssociates() {
    console.time('⏱️ getMonthListForRep API');
    this.ts.getMonthListForRep()
      .subscribe({
        next: (resMonthList: any) => {
          console.timeEnd('⏱️ getMonthListForRep API');
          // this.monthDropdown = resMonthList.data.dates;
          this.monthDropdown = resMonthList.data.filter((d: any) => d.dayDate);
          // 当月のデータがない場合
          if (!this.monthDropdown?.length) {
            this.selectedDate = '';
            this.companiesList = [];
            this.filteredCompaniesList = [];
            this.isLoading = false;
            console.log('⚠️ No data available for current month');
            console.timeEnd('⏱️ Total component load');
            return;
          }
          // console.log(this.monthDropdown);
          const defaultEntry = this.monthDropdown.find((d: any) => d.isDefault) ?? this.monthDropdown[0];
          const [day, month, year] = defaultEntry.dayDate.split('-');
          let newFormat = `${year}-${month}-${day}`;
          this.selectedDate = `${day}-${month}-${year}`;
          // 戻り状態がある場合、元の月を復元
          if (this.pendingReturnState?.selectedDate) {
            this.selectedDate = this.pendingReturnState.selectedDate;
          }
          // this.getAssociatesList(newFormat);
          this.onSearch();
        },
        error: (err: any) => {
          console.timeEnd('⏱️ getMonthListForRep API');
          if(err.status === 401) {
            this.auth.logout();   
				    return
          }
        }
      });
    
    // this.as.getBranches()
    //   .subscribe({
    //     next: (resBranchList: any) => {
    //       this.branchDropdown = resBranchList.data;
    //       // console.log(this.branchDropdown);
    //     },
    //     error: (err: any) => {
    //       if(err.status === 401) {
    //         this.auth.logout(); 
		// 	      return			
    //       }
    //     }
    //   });
    
    // this.as.getCustomers()
    //   .subscribe({
    //     next: (resCustmomersList: any) => {
    //       this.customerDropdown = resCustmomersList.data;
    //       // console.log(this.customerDropdown);
    //     },
    //     error: (err: any) => {
    //       if(err.status === 401) {
    //         this.auth.logout();
		// 	      return	
    //       }
    //     }
    //   });

  }

  onSearch() {
    // console.log('Branch:', this.selectedBranch);
    // console.log('Customer:', this.selectedCustomer);
    // console.log('Date:', this.selectedDate);
    if (this.selectedDate) {
      this.weekEndingDate = this.getDate(this.selectedDate);
    } else {
      this.weekEndingDate = '';
    }
    this.timeSheetDate = Base64UrlService.encode(this.en.encryptionAES(this.weekEndingDate));
    const filters = {
      weekEndingDate: this.weekEndingDate,
      companyId: this.selectedCustomer,
      departmentId: this.selectedService,
      sectionId: this.selectedSection
    }
    // departmentId: this.selectedBranch
    if (this.selectedCustomer === '-1') {
      // console.log("list company")
      this.displayByCompany = false;
      this.getCompanyList(filters);
    } else {
      // console.log("list Section");
      this.getAssociatesList(filters);
    }
  }

  onCmpSearch(compId: any, sectionId: any) {
    // 1つ目テーブルの状態を保存
    this.savedSearchText = this.searchText;
    this.savedDt1First = this.dt1?.first ?? 0;

    this.selectedCustomer = compId;
    // this.selectedService = sectionId;
    this.selectedSection = sectionId;
    
    // Store company and section names from the selected row
    const selectedRow = this.companiesList.find(c => c.customerId === compId && c.sectionId === sectionId);
    if (selectedRow) {
      this.selectedCompanyName = selectedRow.customerName;
      this.selectedSectionName = selectedRow.section;
    }
    
    console.log(this.selectedCustomer+' - '+this.selectedService)
    this.onSearch();
  }

  goBack() {
    this.displayByCompany = false;
    this.selectedCustomer = '-1';
    this.selectedSection = '-1';
    this.associatesList = [];
    this.filteredAssociatesList = [];
    this.associatesSearchText = '';
    // 検索テキストを復元
    this.searchText = this.savedSearchText;
    // ページ位置を復元（次の描画サイクル後に適用）
    setTimeout(() => {
      if (this.dt1) {
        this.dt1.first = this.savedDt1First;
      }
    }, 0);
  }

  navigateToTimesheet(timesheetId: string, userId: string) {
    const state = {
      customerId: this.selectedCustomer,
      sectionId: this.selectedSection,
      selectedDate: this.selectedDate,
      selectedCompanyName: this.selectedCompanyName,
      selectedSectionName: this.selectedSectionName,
      dt2First: this.dt2?.first ?? 0,
      savedSearchText: this.savedSearchText,
      savedDt1First: this.savedDt1First
    };
    sessionStorage.setItem('rep_home_return_state', JSON.stringify(state));
    window.location.href = `representative-timesheet/${timesheetId}/${userId}`;
  }

  clearAll() {
    this.selectedDate = '';
    this.selectedCustomer = '-1';
    this.selectedBranch = '-1';
    this.totalCount = 0;
    this.displayByCompany = false;
    this.associatesList = [];
    this.filteredAssociatesList = [];
  }
  // fncCng(event: any) {
  //   let dateFormat = this.getDateFromEvent(event);
  //   this.getAssociatesList(dateFormat);
  // }

  private getDateFromEvent(event: any): string {
    if (!event) return '2025-07-01';
    const target = event.target as HTMLSelectElement;
    return this.getDate(target.value);
  }

  getCompanyList(filtersObj: any) {
    this.isLoading = true;
    console.time('⏱️ getCompanySection API');
    
    // サーバーサイドページングが有効な場合、ページング情報を追加
    const requestFilters = this.enableServerPaginationCompanies 
      ? { ...filtersObj, page: this.currentPage, pageSize: this.pageSize }
      : filtersObj;
    
    this.as.getCompanySection(requestFilters)
      .subscribe({
        next: (res: any) => {
          console.timeEnd('⏱️ getCompanySection API');
          console.log('📊 Raw companies data count:', res.data?.length);
          console.time('⏱️ Company Data Processing');
          
          if (res.status) {
            // ページング情報を保存（サーバーサイドページングの場合）
            if (res.pagination) {
              this.totalRecords = res.pagination.totalCount;
              this.totalPages = res.pagination.totalPages;
              this.currentPage = res.pagination.currentPage;
              console.log('📊 Server pagination:', res.pagination);
            }
            
            // flatMapを効率的に処理（flatMap後にcustomerOfficeCode順にソート）
            // CustomerOfficeCodeはTimesheetSummaryCompanySectionGroupDtoに含まれる(バックエンド側で追加済み)
            this.companiesList = res.data.flatMap((row: any) => {
              const sections = row.timesheetSummaryCompanySectionGroupDto || [];
              const companyName = row.customerName;
              const companyId = row.customerID;
              // 表示と一致させるためスライス済み文字列で検索テキストを構築
              // セクションがない場合は企業のみ返す
              if (!sections.length) {
                return [{
                  customerId: companyId,
                  customerName: companyName,
                  section: null,
                  comSearchText: (companyName ?? '').toLowerCase()
                }];
              }

              // セクションごとに展開（検索テキストを効率的に構築）
              return sections.map((x: any) => ({
                ...x,
                customerId: companyId,
                customerName: companyName,
                comSearchText: `${companyName ?? ''} ${x.section ?? ''}`.toLowerCase()
              }));
            }).sort((a: any, b: any) =>
              (a.customerOfficeCode ?? '').localeCompare(b.customerOfficeCode ?? '', 'en', { sensitivity: 'variant' })
            );
            console.log(this.companiesList);
            console.timeEnd('⏱️ Company Data Processing');
            console.log('📊 Processed companies count:', this.companiesList.length);
            
            // 検索テキストが残っている場合は再フィルタ、それ以外は全件セット
            const searchLower = this.searchText.toLowerCase().trim();
            this.filteredCompaniesList = searchLower
              ? this.companiesList.filter((item: any) => item.comSearchText?.includes(searchLower))
              : [...this.companiesList];
            
            // サーバーサイドページングの場合、visibleDataComは全てのfilteredCompaniesList
            if (this.enableServerPaginationCompanies) {
              this.visibleDataCom = this.filteredCompaniesList;
              this.totalCount = this.totalRecords;
            } else {
              setTimeout(() => this.updateVisibleDataCom(), 0);
              this.totalCount = this.companiesList.length;
            }
            
            console.timeEnd('⏱️ Total component load');
            console.log('✅ Company list ready');
            this.isLoading = false;
            // タイムシート画面から戻った場合、表２を復元
            if (this.pendingReturnState) {
              this.onCmpSearch(this.pendingReturnState.customerId, this.pendingReturnState.sectionId);
              // onCmpSearchが上書きした保存値を元の値で復元（表２のBackボタン用）
              this.savedSearchText = this.pendingReturnState.savedSearchText ?? '';
              this.savedDt1First = this.pendingReturnState.savedDt1First ?? 0;
            }
          } else {
            this.companiesList = [];
            this.filteredCompaniesList = [];
            this.totalCount = 0;
            console.timeEnd('⏱️ Company Data Processing');
            console.timeEnd('⏱️ Total component load');
            this.isLoading = false;
          }
        },
        error: (err: any) => {
          console.timeEnd('⏱️ getCompanySection API');
          console.timeEnd('⏱️ Total component load');
          this.isLoading = false;
          console.log(err);
          if (err.status == 401) {
            this.auth.logout();
            return
          }
        }
      });

  }

  getAssociatesList(filtersObj: any) {
    this.isLoading = true;
    console.time('⏱️ getAssociatesByCompany API');
    
    // サーバーサイドページングが有効な場合、ページング情報を追加
    const requestFilters = this.enableServerPaginationAssociates 
      ? { ...filtersObj, page: this.currentPageAssociates, pageSize: this.pageSizeAssociates }
      : filtersObj;
    
    this.as.getAssociatesByCompany(requestFilters)    
      .subscribe({
        next: (res: any) => {
          console.timeEnd('⏱️ getAssociatesByCompany API');
          console.log('📊 Raw associates data count:', res.data?.length);
          console.time('⏱️ Associates Data Processing');
          if (res.status) {
            // ページング情報を保存（サーバーサイドページングの場合）
            if (res.pagination) {
              this.totalRecordsAssociates = res.pagination.totalCount;
              this.totalPagesAssociates = res.pagination.totalPages;
              this.currentPageAssociates = res.pagination.currentPage;
              console.log('📊 Server pagination (Associates):', res.pagination);
            }
            
            // 最適化: セクション単位からスタッフ単位にフラット化（第1ソート: customerOfficeCode, 第2ソート: userCode）
            this.associatesList = [...res.data].sort((a: any, b: any) =>
              (a.customerOfficeCode ?? '').localeCompare(b.customerOfficeCode ?? '', 'en', { sensitivity: 'variant' })
            ).flatMap((row: any) => {
              const sectionText = (row.sectionName ?? '').toLowerCase();
              return [...(row.timesheetSummary ?? [])].sort((a: any, b: any) =>
                (a.userCode ?? '').localeCompare(b.userCode ?? '', 'en', { sensitivity: 'variant' })
              ).map((x: any) => ({
                ...x,
                timesheetId: Base64UrlService.encode(this.en.encryptionAES(x.timesheetId.toString())),
                userid: Base64UrlService.encode(this.en.encryptionAES(x.userid.toString())),
                userIdOrg: x.userid,
                userCode: x.userCode,
                searchText: `${sectionText} ${(x.section ?? '').toLowerCase()}`
              }));
            });
            console.log(this.associatesList);
            console.timeEnd('⏱️ Associates Data Processing');
            console.log('📊 Processed associates count:', this.associatesList.length);
            this.displayByCompany = true;
            
            // 検索テキストが残っている場合は再フィルタ、それ以外は全件セット
            const assocSearchLower = this.associatesSearchText.toLowerCase().trim();
            this.filteredAssociatesList = assocSearchLower
              ? this.associatesList.filter((item: any) => item.searchText?.includes(assocSearchLower))
              : [...this.associatesList];
            
            // サーバーサイドページングの場合、visibleDataは全てのfilteredAssociatesList
            if (this.enableServerPaginationAssociates) {
              this.visibleData = this.filteredAssociatesList;
              this.totalCount = this.totalRecordsAssociates;
            } else {
              this.totalCount = this.associatesList.length;
            }
            
            console.timeEnd('⏱️ Total component load');
            console.log('✅ Associates list ready');
            this.isLoading = false;
            // dt2のページ位置を復元
            if (this.pendingReturnState) {
              const dt2First = this.pendingReturnState.dt2First ?? 0;
              this.pendingReturnState = null;
              if (dt2First > 0) {
                setTimeout(() => { if (this.dt2) { this.dt2.first = dt2First; } }, 0);
              }
            }
          } else {
            this.associatesList = [];
            this.filteredAssociatesList = [];
            this.totalCount = 0;
            console.timeEnd('⏱️ Total component load');
            this.isLoading = false;
            alert(res.message);
          }
        },
        error: (err: any) => {
          console.timeEnd('⏱️ getAssociatesByCompany API');
          console.timeEnd('⏱️ Total component load');
          this.isLoading = false;
          if (err.status === 401) {
            this.auth.logout();
            return;
          }
        }
      });

  }
  ngAfterViewInit() {
    // 
  }

  applyFilterGlobal($event: Event) {
    const input = $event.target as HTMLInputElement;
    this.searchText = input.value;
    const searchLower = this.searchText.toLowerCase().trim();
    this.filteredCompaniesList = searchLower
      ? this.companiesList.filter((item: any) => item.comSearchText?.includes(searchLower))
      : [...this.companiesList];
    this.updateVisibleDataCom();
  }

  // Update filteredData whenever filter or pagination changes
  onFilter(event: any) {
    this.updateVisibleDataCom();
    this.updateVisibleData();
  }

  onPage(event: any) {
    if (this.displayByCompany) {
      // 派遣社員ビュー
      if (this.enableServerPaginationAssociates) {
        this.currentPageAssociates = (event.first / event.rows) + 1;
        this.pageSizeAssociates = event.rows;
        this.onSearch(); // APIから新しいページのデータを取得
      } else {
        this.updateVisibleData(event);
      }
    } else {
      // 会社ビュー
      if (this.enableServerPaginationCompanies) {
        this.currentPage = (event.first / event.rows) + 1;
        this.pageSize = event.rows;
        this.onSearch(); // APIから新しいページのデータを取得
      } else {
        this.updateVisibleDataCom(event);
      }
    }
  }

  onSort() {
    this.updateVisibleDataCom();
    this.updateVisibleData();
  }

  updateVisibleDataCom(event?: any) {   
    if (!this.dt1) {
      this.visibleDataCom = this.companiesList;
      return;
    }
    const filtered = this.dt1.filteredValue ?? this.filteredCompaniesList;
    const start = event?.first ?? this.dt1.first ?? 0;
    const rows = event?.rows ?? this.dt1.rows ?? 3;
    const end = start + rows;
    this.visibleDataCom = filtered.slice(start, end);
  }

  updateVisibleData(event?: any) {   
    if (!this.dt2) {
      this.visibleData = this.filteredAssociatesList;
      return;
    }
    const filtered = this.dt2.filteredValue ?? this.filteredAssociatesList;
    const start = event?.first ?? this.dt2.first ?? 0;
    const rows = event?.rows ?? this.dt2.rows ?? 3;
    const end = start + rows;
    this.visibleData = filtered.slice(start, end);
  }

  // Compute totals dynamically (フィルター後の全件合計 - ページングには追随しない)
  private get _comData(): any[] {
    return this.filteredCompaniesList ?? [];
  }

  get totalRegular() {
    if (!this._comData.length) return '00:00';
    let totalSeconds = 0;

    this._comData.forEach((item: any) => {
      const timeStr = item?.regular;
      if (!timeStr) return;

      // Split into hours/minutes
      const parts = String(timeStr).split(':').map(Number);
      let h = 0, m = 0;

      if (parts.length === 2) [h, m] = parts;
      else if (parts.length === 1) h = parts[0];

      if (!isNaN(h) && !isNaN(m)) {
        totalSeconds += (h * 3600 + m * 60);
      }
    });
    return this.formatSeconds(totalSeconds);
  }
  
  get totalOverTime() {
    if (!this._comData.length) return '00:00';
    let totalSeconds = 0;

    this._comData.forEach((item: any) => {
      const timeStr = item?.overtime;
      if (!timeStr) return;

      // Split into hours/minutes
      const parts = String(timeStr).split(':').map(Number);
      let h = 0, m = 0;

      if (parts.length === 2) [h, m] = parts;
      else if (parts.length === 1) h = parts[0];

      if (!isNaN(h) && !isNaN(m)) {
        totalSeconds += (h * 3600 + m * 60);
      }
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalMn() {
    if (!this._comData.length) return '00:00';
    let totalSeconds = 0;

    this._comData.forEach((item: any) => {
      const timeStr = item?.midnightOvertime;
      if (!timeStr) return;

      // Split into hours/minutes
      const parts = String(timeStr).split(':').map(Number);
      let h = 0, m = 0;

      if (parts.length === 2) [h, m] = parts;
      else if (parts.length === 1) h = parts[0];

      if (!isNaN(h) && !isNaN(m)) {
        totalSeconds += (h * 3600 + m * 60);
      }
    });
    return this.formatSeconds(totalSeconds);
  }
  get overAllTotal() {
    if (!this._comData.length) return '00:00';
    let totalSeconds = 0;

    this._comData.forEach((item: any) => {
      const timeStr = item?.total;
      if (!timeStr) return;

      // Split into hours/minutes
      const parts = String(timeStr).split(':').map(Number);
      let h = 0, m = 0;

      if (parts.length === 2) [h, m] = parts;
      else if (parts.length === 1) h = parts[0];

      if (!isNaN(h) && !isNaN(m)) {
        totalSeconds += (h * 3600 + m * 60);
      }
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalNotSubmit() {
    return this._comData.reduce((sum: number, item: any) => sum + (item?.notSubmit ?? 0), 0);
  }
  get totalSubmit() {
    return this._comData.reduce((sum: number, item: any) => sum + (item?.submit ?? 0), 0);
  }
  get totalReject() {
    return this._comData.reduce((sum: number, item: any) => sum + (item?.reject ?? 0), 0);
  }
  get totalApprove() {
    return this._comData.reduce((sum: number, item: any) => sum + (item?.approve ?? 0), 0);
  }
  get totalHome() {
    return this._comData.reduce((sum: number, item: any) => sum + (item?.teleWork ?? 0), 0);
  }
  get totalAbsence() {
    return this._comData.reduce((sum: number, item: any) => sum + (item?.absence ?? 0), 0);
  }
  get totalPh() {
    return this._comData.reduce((sum: number, item: any) => sum + (item?.paidHoliday ?? 0), 0);
  }

  get totalResource() {
    return this._comData.reduce((sum: number, item: any) => sum + (item?.userCount ?? 0), 0);
  }

  get totalContract() {
    return this._comData.reduce((sum: number, item: any) => sum + (item?.contractCount ?? 0), 0);
  }

  // Section totals (フィルター後の全スタッフ合計 - フラット化済みfilteredAssociatesListを直参照)
  private get _assocData(): any[] {
    return this.filteredAssociatesList ?? [];
  }

  get totalRegularSection() {
    if (!this._assocData.length) return '00:00';
    let totalSeconds = 0;
    this._assocData.forEach((item: any) => {
      const timeStr = item?.regular;
      if (!timeStr) return;
      const parts = String(timeStr).split(':').map(Number);
      let h = 0, m = 0;
      if (parts.length === 2) [h, m] = parts;
      else if (parts.length === 1) h = parts[0];
      if (!isNaN(h) && !isNaN(m)) totalSeconds += (h * 3600 + m * 60);
    });
    return this.formatSeconds(totalSeconds);
  }

  get totalOverTimeSection() {
    if (!this._assocData.length) return '00:00';
    let totalSeconds = 0;
    this._assocData.forEach((item: any) => {
      const timeStr = item?.overtime;
      if (!timeStr) return;
      const parts = String(timeStr).split(':').map(Number);
      let h = 0, m = 0;
      if (parts.length === 2) [h, m] = parts;
      else if (parts.length === 1) h = parts[0];
      if (!isNaN(h) && !isNaN(m)) totalSeconds += (h * 3600 + m * 60);
    });
    return this.formatSeconds(totalSeconds);
  }

  get totalMnSection() {
    if (!this._assocData.length) return '00:00';
    let totalSeconds = 0;
    this._assocData.forEach((item: any) => {
      const timeStr = item?.midnightOvertime;
      if (!timeStr) return;
      const parts = String(timeStr).split(':').map(Number);
      let h = 0, m = 0;
      if (parts.length === 2) [h, m] = parts;
      else if (parts.length === 1) h = parts[0];
      if (!isNaN(h) && !isNaN(m)) totalSeconds += (h * 3600 + m * 60);
    });
    return this.formatSeconds(totalSeconds);
  }

  get overAllTotalSection() {
    if (!this._assocData.length) return '00:00';
    let totalSeconds = 0;
    this._assocData.forEach((item: any) => {
      const timeStr = item?.total;
      if (!timeStr) return;
      const parts = String(timeStr).split(':').map(Number);
      let h = 0, m = 0;
      if (parts.length === 2) [h, m] = parts;
      else if (parts.length === 1) h = parts[0];
      if (!isNaN(h) && !isNaN(m)) totalSeconds += (h * 3600 + m * 60);
    });
    return this.formatSeconds(totalSeconds);
  }

  get totalNotSubmitSection() {
    return this._assocData.reduce((sum: number, item: any) => sum + (item?.notSubmit ?? 0), 0);
  }
  get totalSubmitSection() {
    return this._assocData.reduce((sum: number, item: any) => sum + (item?.submit ?? 0), 0);
  }
  get totalRejectSection() {
    return this._assocData.reduce((sum: number, item: any) => sum + (item?.reject ?? 0), 0);
  }
  get totalApproveSection() {
    return this._assocData.reduce((sum: number, item: any) => sum + (item?.approve ?? 0), 0);
  }
  get totalHomeSection() {
    return this._assocData.reduce((sum: number, item: any) => sum + (item?.teleWork ?? 0), 0);
  }
  get totalAbsenceSection() {
    return this._assocData.reduce((sum: number, item: any) => sum + (item?.absence ?? 0), 0);
  }

  get totalPhSection() {
    return this._assocData.reduce((sum: number, item: any) => sum + (item?.paidHoliday ?? 0), 0);
  }

  formatSeconds(totalTime: number): string {
    const hours = Math.floor(totalTime / 3600);
    const minutes = Math.floor((totalTime % 3600) / 60);
    // const seconds = totalTime % 60;
    // :${ this.pad(seconds) }
    return `${this.pad(hours)}:${this.pad(minutes)}`;
  }

  pad(num: number): string {
    return num.toString().padStart(2, '0');
  }
  
  getMonthYear(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  }
  getMonth(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { month: 'short'});
  }
  getYear(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { year: 'numeric'});
  }
  getDate(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    const yyyy = date.getFullYear();
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const dd = date.getDate().toString().padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  }

  applyEncryption(dt: any) {
    dt.forEach((elm: any, ind: any) => {
      elm.timesheetSummary.forEach((obj: any, index: any) => {
        const encryptedId = Base64UrlService.encode(
          this.en.encryptionAES(obj.timesheetId.toString())
        );
        elm.timesheetSummary[index].timesheetId = encryptedId;
      }) 
    });
    return dt;
  }

  onGlobalFilter(event: Event) {
    const input = event.target as HTMLInputElement;
    this.associatesSearchText = input.value;
    const searchLower = this.associatesSearchText.toLowerCase().trim();
    this.filteredAssociatesList = searchLower
      ? this.associatesList.filter((item: any) => item.searchText?.includes(searchLower))
      : [...this.associatesList];
    // ページを先頭にリセットしてからvisibleDataを更新
    if (this.dt2) {
      this.dt2.first = 0;
    }
    this.updateVisibleData();
  }

  createSingleAll(staffId: string, loginId: string) {
    //let date = this.dropDowndate;
	let curDateArr = this.selectedDate.split('-');
    let newDateFormat = `${curDateArr[2]}-${curDateArr[1]}-${curDateArr[0]}`;
    const yearMonth = `${curDateArr[2]}-${curDateArr[1]}`;
    const fileName = loginId === 'All'
      ? `Summary-${yearMonth}-ALL.zip`
      : `Summary-${yearMonth}-${loginId}.zip`;
      this.ts.downloadTimesheet(newDateFormat, staffId)
        .subscribe({
          next: (res: any) => {
            // Create a blob from the response
            const blob = new Blob([res.body ?? res], { type: 'application/zip' });

            // Create a temporary download link
            const fileURL = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = fileURL;

            // Optional: derive filename from API or generate dynamically
            a.download = fileName;

            // Trigger the download
            a.click();

            // Cleanup
            URL.revokeObjectURL(fileURL);
          },
          error: (err: any) => {
            console.error('Error downloading file:', err);
            if (err.status == 401) {
              this.auth.logout();
              return
            }
          }
      })
  }

  downloadContract(staffId: string, loginId: string) {
    let curDateArr = this.selectedDate.split('-');
    let newDateFormat = `${curDateArr[2]}-${curDateArr[1]}-${curDateArr[0]}`;
    const yearMonth = `${curDateArr[2]}-${curDateArr[1]}`;
    const fileName = loginId === 'All'
      ? `Contract-${yearMonth}-ALL.zip`
      : `Contract-${yearMonth}-${loginId}.zip`;
      this.ts.downloadContract(newDateFormat, staffId)
        .subscribe({
          next: (res: any) => {
            // Create a blob from the response
            const blob = new Blob([res.body ?? res], { type: 'application/zip' });

            // Create a temporary download link
            const fileURL = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = fileURL;

            // Optional: derive filename from API or generate dynamically
            a.download = fileName;

            // Trigger the download
            a.click();

            // Cleanup
            URL.revokeObjectURL(fileURL);
          },
          error: (err: any) => {
            console.error('Error downloading contract:', err);
            if (err.status == 401) {
              this.auth.logout();
              return
            }
          }
      })
  }
}
